import request from "@/utils/request";

// 登录
export function userLogin(data) {
  return request({
    url: "/api/system/login/",
    method: "post",
    data: data
  })
}

// 登出
export function userLogout() {
  return request({
    url: "/api/system/logout/",
    method: "get",
  })
}

// 登录时获取可用项目列表
export function loginUserProjectList() {
  return request({
    url: "/api/project/login-user-project/",
    method: "get",
  })
}

// 通过token获取用户详情
export function tokenUserDetail() {
  return request({
    url: "/api/system/token-user/",
    method: "get",
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js